import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertNotificationService } from '../../../services/alert-notification.service';

export interface AlertNotification {
  type: 'success' | 'error' | 'warning';
  message: string;
  fadeOut?: boolean;
  show?: boolean;
}
@Component({
  selector: 'alert-notification',
  imports: [CommonModule],
  templateUrl: './alert-notification.component.html',
  styleUrl: './alert-notification.component.scss'
})
export class AlertNotificationComponent implements OnInit, OnDestroy {
  notifications: AlertNotification[] = [];

  private readonly subscription = new Subscription();
  private readonly timeouts = new Set<ReturnType<typeof setTimeout>>();

  constructor(private alertNotificationService: AlertNotificationService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.alertNotificationService.notifications$.subscribe(notification => {
        this.notifications.push(notification);

        this.schedule(() => {
          notification.show = true;
        }, 10);

        this.schedule(() => {
          notification.fadeOut = true;
          this.schedule(() => this.remove(notification), 500);
        }, 3000);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    this.timeouts.clear();
  }

  private schedule(action: () => void, delay: number): void {
    const timeout = setTimeout(() => {
      this.timeouts.delete(timeout);
      action();
    }, delay);
    this.timeouts.add(timeout);
  }

  private remove(notification: AlertNotification): void {
    const index = this.notifications.indexOf(notification);
    if (index > -1) {
      this.notifications.splice(index, 1);
    }
  }
}
